import { useMainStore } from '../../store/mainStore';

export const useEventIndicator = () => {
  const setEventIndicatorData = useMainStore((state) => state.setEventIndicatorData);
  return setEventIndicatorData;
};
